// extracted by mini-css-extract-plugin
export default {"shopify_status":"styles_shopify_status__Q0LFT","shopify_status_error":"styles_shopify_status_error__KRgwf"};